<template>
  <div>
    <t-sub-nav
      class="mb-5"
      :loading="loading"
      :items="$secondaryNav.customerDefaultPolicyNavItems()"
    />

    <b-row class="mb-6">
      <b-col>
        <t-data-table
          data-test-id="default-policy-data-table"
          with-filter
          :filter-placeholder="$t('Search Domains')"
          :table-data="domains"
          :actions="tableActions"
          :loading="loading"
          user-role="customer"
          @on-delete="onDelete"
          @on-add="onAdd"
          @on-row-clicked="onRowClicked"
          @on-import="onImport()"
          @on-export="onExport"
          :searchExports="searchExports"
          @export-headers="exportedHeaders"
        />
      </b-col>
    </b-row>

    <section>
      <t-uploader :dialog="modal" @submitFiles="domainSubmit"></t-uploader>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import TUploader from "@/components/TUploader";
export default {
  components: {
    TUploader,
  },
  layout: "customer",
  data() {
    return {
      loading: true,
      currentHeaders: null,
      fetching: false,
      tableActions: {
        add: {
          enabled: true,
          label: this.$t("Add Domain"),
          actions: [
            {
              text: this.$t("Allow a Domain"),
              value: {
                modal: "t-add-domain",
                dataTestId: "modal-add-domain-allow",
                title: this.$t("Allow a domain"),
                modalData: {
                  type: "allow",
                  toPolicy: true,
                  isGlobal: false,
                },
                props: {
                  size: "lg",
                  okTitle: this.$t("Allow Domain"),
                },
              },
            },
            {
              text: this.$t("Block a Domain"),
              value: {
                modal: "t-add-domain",
                dataTestId: "modal-add-domain-block",
                title: this.$t("Block a domain"),
                modalData: {
                  type: "block",
                  toPolicy: true,
                  isGlobal: false,
                },
                props: {
                  size: "lg",
                  okTitle: this.$t("Block Domain"),
                },
              },
            },
          ],
        },
        export: { enabled: true },
        import: { enabled: true },
        delete: { enabled: true },
      },
      searchExports: ["domain", "object", "policyname"],

      domains: {
        fields: [
          { value: "domain", text: this.$t("Domain"), sortable: true },
          { value: "object", text: this.$t("Status"), sortable: true },
          { value: "subdomains", text: this.$t("Sub Domains"), sortable: true },
          {
            value: "log_requests",
            text: this.$t("Log Requests"),
            sortable: true,
          },
          { value: "comment", text: this.$t("Comments"), sortable: true },
        ],
        items: [],
      },
    };
  },
  watch: {
    customerDomainList() {
      this.domains.items = this.customerDomainList;
    },
  },
  computed: {
    ...mapGetters("customerDomains", ["customerDomainList"]),
    ...mapGetters("fileUpload", ["modal"]),
    ...mapGetters("authentication", ["selectedUser"]),
    ...mapGetters("customerPolicies", ["selectedCustomerPolicy"]),
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
    ...mapMutations("modal", ["createModal", "showModal"]),

    ...mapActions("customerDomains", [
      "fetchCustomerDomainList",
      "deleteCustomerDomainListEntrys",
      "addBlockAllowedUser",
    ]),
    ...mapActions("fileUpload", ["setDialog", "clearCache"]),
    ...mapActions("toast", ["displayToast"]),

    onImport() {
      this.setDialog(true);
    },
    exportedHeaders(headers) {
      this.currentHeaders = headers;
    },
    onExport(items) {
      if (items.length) {
        const exportData = items.map((res) => {
          let payload = {};
          this.currentHeaders.forEach((headers) => {
            return (payload[headers.value] = res[headers.value]);
          });

          return payload;
        });
        this.$downloadCSV(exportData, "domains");
      } else {
        this.displayToast({
          title: this.$t("Failure"),
          message: this.$t("No domains in table"),
          duration: 2000,
          variant: "danger",
        });
      }
    },
    onAdd(modal) {
      (modal.modalData.toPolicy = true),
        (modal.modalData.policyId = "default"),
        this.createModal({
          ...modal,
          subtitle: this.selectedUser.accountname,
        });

      this.showModal();
    },
    async onDelete(domains) {
      try {
        await this.deleteCustomerDomainListEntrys({
          userId: this.selectedUser.id,
          domains: domains,
        });
        this.displayToast({
          title: this.$t("Success"),
          message: this.$t("Deleted X X", {
            count: domains.length,
            item: this.$t("Domain(s)"),
          }),
          duration: 2000,
          variant: "success",
        });
      } catch (err) {
        console.error(err); // eslint-disable-line no-console
      }
    },
    onRowClicked(item) {
      this.$router.push({
        path: `/customer/content_filtering/domains/${item.id}?t=${item.object}&p=default`,
      });
    },
    async domainSubmit(value) {
      const action = value.domain.split(" ")[0].toLowerCase();
      const files = value.files;
      try {
        await this.addBlockAllowedUser({
          policyId: "default",
          action: action,
          file: files,
          id: this.selectedUser.id,
        });
        this.displayToast({
          title: this.$t("Success"),
          message: this.$t("Updated"),
          duration: 2000,
          variant: "success",
        });
      } finally {
        this.fetchCustomerDomainList({
          id: this.selectedUser.id,
          policyId: "default",
        });
        this.clearCache();
      }
    },
  },
  async created() {
    try {
      await this.fetchCustomerDomainList({
        id: this.selectedUser.id,
        policyId: "default",
      });
    } finally {
      this.loading = false;
    }
  },
  mounted() {
    this.setPageTitle(this.$t("Default Policy"));
    this.setPageSubtitle([
      this.$t(
        "Policies determine what categories of website a user can see. This is your default policy and is automatically assigned to all new locations, devices, users and groups added to WebTitan, unless you apply a policy you have created in Content Filtering > Policies"
      ),
    ]);
  },
};
</script>
